import { Badge } from '../ui/badge';

export const PAYMENT_STATUS = {
    pending: { label: 'Pendiente', cls: 'bg-amber-500/15 text-amber-400 border-amber-500/30' },
    paid: { label: 'Pagado', cls: 'bg-emerald-500/15 text-emerald-400 border-emerald-500/30' },
    overdue: { label: 'Vencido', cls: 'bg-red-500/15 text-red-400 border-red-500/30' },
};
const MONTHS = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
export const fmtPeriod = (p) => { const [y, m] = (p || '').split('-'); return m ? `${MONTHS[Number(m) - 1]} ${y}` : p; };
export const money = (n) => `USD ${Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export function StatusBadge({ status, testid }) {
    const s = PAYMENT_STATUS[status] || PAYMENT_STATUS.pending;
    return <Badge variant="outline" className={s.cls} data-testid={testid}>{s.label}</Badge>;
}

export function PaymentsTable({ payments, onEdit, onHistory, testid = 'payments-table' }) {
    if (!payments.length) return <p className="text-sm text-muted-foreground py-4 text-center" data-testid={`${testid}-empty`}>Aún no hay registros de facturación.</p>;
    return (
        <div className="overflow-x-auto">
            <table className="w-full text-sm" data-testid={testid}>
                <thead><tr className="text-left text-xs text-muted-foreground uppercase">
                    <th className="py-2">Período</th><th>Monto</th><th>Estado</th><th>Fecha de pago</th><th>Método</th><th>Referencia</th>{onEdit && <th>Notas</th>}{onEdit && <th />}
                </tr></thead>
                <tbody>
                    {payments.map(p => (
                        <tr key={p.id} className="border-t border-border/40" data-testid={`payment-row-${p.period}`}>
                            <td className="py-2 capitalize">{fmtPeriod(p.period)}</td>
                            <td className="font-mono">{money(p.amount)}</td>
                            <td><StatusBadge status={p.status} testid={`payment-status-${p.period}`} /></td>
                            <td className="font-mono text-xs">{p.payment_date || '—'}</td>
                            <td>{p.method || '—'}</td>
                            <td className="font-mono text-xs">{p.reference || '—'}</td>
                            {onEdit && <td className="text-xs text-muted-foreground max-w-[180px] truncate" title={p.notes}>{p.notes || '—'}</td>}
                            {onEdit && (
                                <td className="whitespace-nowrap text-right">
                                    <button className="text-xs text-primary hover:underline mr-3" onClick={() => onEdit(p)} data-testid={`payment-edit-${p.period}`}>Editar</button>
                                    <button className="text-xs text-muted-foreground hover:underline" onClick={() => onHistory(p)} data-testid={`payment-history-${p.period}`}>Historial</button>
                                </td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
